/**
 * Utilitaire pour la gestion des erreurs API
 */

export interface ApiError {
  status?: number;
  message: string;
  isAuthError: boolean;
  isForbiddenError: boolean;
}

/**
 * Extrait un message d'erreur lisible à partir d'une erreur Axios
 */
export const getApiErrorMessage = (err: any, defaultMessage: string = 'Une erreur est survenue'): string => {
  // Erreur 403 - Accès interdit
  if (err.response?.status === 403) {
    return err.response?.data?.error ||
           err.response?.data?.detail ||
           'Vous n\'avez pas accès à cette ressource.';
  }

  // Erreur 401 - Non authentifié
  if (err.response?.status === 401) {
    return 'Veuillez vous connecter pour accéder à cette ressource.';
  }

  // Erreur 404 - Non trouvé
  if (err.response?.status === 404) {
    return 'La ressource demandée n\'existe pas.';
  }

  // Erreur 500 - Erreur serveur
  if (err.response?.status >= 500) {
    return 'Une erreur serveur est survenue. Veuillez réessayer plus tard.';
  }

  // Erreur réseau
  if (err.code === 'ERR_NETWORK') {
    return 'Impossible de se connecter au serveur. Vérifiez votre connexion internet.';
  }

  // Message d'erreur de l'API
  return err.response?.data?.detail ||
         err.response?.data?.error ||
         err.response?.data?.message ||
         defaultMessage;
};

/**
 * Parse une erreur API et retourne un objet structuré
 */
export const parseApiError = (err: any, defaultMessage: string = 'Une erreur est survenue'): ApiError => {
  const status = err.response?.status;

  return {
    status,
    message: getApiErrorMessage(err, defaultMessage),
    isAuthError: status === 401,
    isForbiddenError: status === 403,
  };
};
